<template>
  <div class="results-analysis">
    <div style="width: 1080px;padding: 40px 0 65px" class="flex-column items-center justify-center">
      <div class="title-box">
        <div class="ai-icon"></div>
        <div class="title-icon"></div>
      </div>
      <div class="title-message">上传技术成果，帮您深度解析技术优劣势</div>
      <div class="content-bg">
        <div class="content-box">
          <div class="input-content">
            <el-input
              type="textarea"
              resize="none"
              placeholder="您可以在这里描述您的成果，例如：
成果面向产业方向是：xxxxxxxxxxxxxxx；
主要解决问题是：xxxxxxxxxxxxxxx；
成果方案描述：xxxxxxxxxxxxxxx；
请推荐几家潜在的可以合作的机构；
建议1000字以内。"
              v-model="textarea"
              maxlength="1000"
            >
            </el-input>
          </div>
          <div class="upload-file">
            <el-upload
              class="upload-demo"
              drag
              action="null"
              :multiple="false"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleFileChange"
              accept=".doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx"
            >
              <div class="flex-column items-center justify-center" style="height: 100%" v-if="!uploadFile">
                <img width="40" height="32" :src="uploadIcon" alt="">
                <div class="upload_text">AI文档解析，<span>点击上传</span></div>
                <p style="font-size: 12px;color: rgba(0,0,0,0.45);padding-top: 10px">建议上传文件不超过20MB</p>
                <div class="upload-line"><div></div>上传格式<div></div></div>
                <div class="flex justify-center">
                  <div class="upload-img">
                    <img width="24" height="22" :src="word" alt="">
                    <img width="24" height="22" :src="excel" alt="">
                    <img width="22" height="22" :src="ppt" alt="">
                    <img width="22" height="22" :src="pdf" alt="">
                  </div>
                </div>
              </div>
              <div class="flex-column items-center justify-center show-file" v-else>
                <div class="flex-column items-center" style="cursor: default" @click.stop="()=>{}">
                  <img width="44" height="46" :src="fileType" alt="">
                  <p class="file-name ellipsis">{{ uploadFile.name }}</p>
                </div>
                <div class="upload-success">
                  <i class="el-icon-upload-success el-icon-circle-check"></i>上传成功
                </div>
                <div class="operation-btn">
                  <span>重新上传</span>
                  <span @click.stop="deleteFile">删除</span>
                </div>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="upload-btn">
        <el-button :loading="loading" @click="handleSubmit">立即识别</el-button>
      </div>
    </div>
    <!-- 付费弹窗 -->
    <paymentDialog ref="achievementPayment"  payType="成果分析" />
  </div>
</template>

<script>
import uploadIcon from '@/assets/images/common/upload-icon.png';
import ppt from '@/assets/images/achievement/achievement-ppt.png';
import pdf from '@/assets/images/achievement/achievement-pdf.png';
import word from '@/assets/images/achievement/achievement-word.png';
import excel from '@/assets/images/achievement/achievement-excel.png';
import defaultFile from '@/assets/images/achievement/default-file.png';
import { resultsIndexMixin } from '@/mixin/resultsAnalysis/resultsMixin';
import paymentDialog from '@/components/PaymentDialog.vue';

export default {
  name: 'resultsAnalysis',
  mixins: [ resultsIndexMixin ],
  components: { paymentDialog },
  props: {},
  data() {
    return {
      uploadIcon,
      ppt,
      pdf,
      word,
      excel,
      defaultFile,
    }
  },
  created() {},
  watch: {}
};
</script>

<style scoped lang="less">
.results-analysis {
  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  background-image: url("~@/assets/images/bg.png");
  background-color: #011040;
  background-size: 100% 100%;
  background-position: 100% 100%;
  background-repeat: no-repeat;

  .title-box {
    display: flex;
    align-items: center;
    justify-content: center;
    .ai-icon {
      width: 32px;
      height: 31px;
      margin-right: 12px;
      background-size: 100% 100%;
      background-image: url("~@/assets/images/common/ai-icon.png");
    }
    .title-icon {
      width: 164px;
      height: 29px;
      background-size: 100% 100%;
      background-image: url("~@/assets/images/common/achievement-title.png");
    }
  }

  .title-message {
    font-family: PingFang SC;
    margin-top: 18px;
    font-size: 20px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    color: #ffffff;
    letter-spacing: 1px;
    opacity: 0.85;
    user-select: none;
  }

  .content-bg {
    width: 1080px;
    height: 450px;
    box-sizing: border-box;
    margin-top: 25px;
    padding: 20px;
    border: 1px solid #3D7BE1;
    border-radius: 12px;
    background: rgba(61, 123, 225, 0.2);
    box-shadow: 0 2px 8px 0 rgba(6, 40, 86, 0.06);

    .content-box {
      display: flex;
      justify-content: space-between;
      height: 100%;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 8px 0 rgba(6, 40, 86, 0.06);
    }

    .input-content {
      width: 50%;
      padding: 20px 10px 20px 20px;
    }


    /deep/ .el-textarea {
      height: 100%;
    }

    /deep/ .el-textarea__inner {
      border: none;
      height: 100%;
      padding: 0;
      font-size: 16px !important;
      color: #000000;
    }
    .upload-file{
      width:  50%;
      height: calc(100% - 40px);
      padding: 20px 20px 20px 10px;
    }
    .show-file {
      flex-shrink: 0;
      height: inherit;
      padding: 0 40px;
      .file-name {
        width: 350px;
        color: #666666;
        font-size: 14px;
        line-height: 16px;
        margin-top: 20px;
        cursor: default;
      }
      .upload-success {
        margin-top: 16px;
        font-size: 16px;
        color: rgba(0,194,124,0.9);
        cursor: default;
        i {
          color: inherit;
          margin-right: 2px;
        }
      }
      .operation-btn {
        margin-top: 12px;
        font-size: 14px;
        span+span {
          margin-left: 15px;
        }
        span {
          user-select: none;
          cursor: pointer;
          &:first-child {
            color: #1072EC;
          }
          &:last-child {
            color: tomato;
          }
        }
      }
    }
    /deep/.upload-demo{
      height: 100%;
      width: 100%;
    }
    /deep/.el-upload{
      height: 100%;
      width: 100%;
    }
    /deep/.el-upload-dragger{
      height: 100%;
      width: 100%;
    }
    .upload_text{
      color: #000000;
      font-size: 16px;
      margin-top: 15px;
      span{
        color: #1072EC;
        cursor: pointer;
      }
    }
    .upload-line{
      font-size: 14px;
      color: #000000;
      opacity: 0.65;
      justify-content: center;
      display: flex;
      align-items: center;
      margin-top: 35px;
      div{
        width: 60px;
        height: 1px;
        margin: 0 14px;
        opacity: 0.65;
        background-color: #000000;
      }
    }
    .upload-img{
      margin-top: 20px;
      height: 22px;
      display: flex;
      width: 190px;
      justify-content: space-between;
    }
  }

  .upload-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 25px;

    /deep/ .el-button {
      width: 200px;
      height: 60px;
      color: #ffffff;
      background: #0D8AFF;
      border: none;
      border-radius: 30px !important;
      box-shadow: 0px -5px 12px 0px rgba(10,114,255,0.26), 0px 5px 12px 0px rgba(10,114,255,0.3);
    }
  }
}
</style>
